// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ourProducts.module.css */
.ourProducts_ourProductStaticBg__f95iI{
    /* background-color: aqua; */
    /* background-image: url("../../assets/images/Wallpaper.jpg"); */
  /* background-repeat: no-repeat;
  background-attachment: fixed; */
    padding: 100px 0px;
    margin-top: -100px;
    z-index: 0;
}
.ourProducts_outerContainer__Je\\+01 {
    margin-left: 4%;
    margin-right:4%;
    padding: 0px 100px 100px 100px;
    animation: ourProducts_slideInFromBottom__SsQim 1s ease-in-out;
    z-index: 1;
}
.ourProducts_CardMedia__lnD-r{
    height: 110px;
    background-color: aquamarine;
}

@keyframes ourProducts_slideInFromBottom__SsQim {
    0% {
      transform: translateY(20px); 
      opacity: 0; 
    }
    100% {
      transform: translateY(0); 
      opacity: 1; 
    }
  }

  .ourProducts_productCardDescription__MDD95{
    height: 50px;
    text-overflow: ellipsis;
  }
.ourProducts_topicContainer__VP1SM {
    text-align: center;
    margin: 0 auto;
}

.ourProducts_topic__fYv9o {
    font-size: 3rem;
    font-family: "Livvic", serif;
    font-weight: 700;
    font-style: normal;
    margin: 0;
    margin-top: 100px;
    display: flex;
    justify-content: center;
}

.ourProducts_description__SqEF1{
 margin: 50px;
 align-items: center;
 text-align: center;
 justify-content: center;
}

.ourProducts_productContainer__YUXfl {
    display: flex;
    flex-direction: column;
    background: linear-gradient(0deg, rgba(255, 197, 197, 0.00) 0%, #fadfdf 100.51%);
    border: none;
    padding: 0;
    text-align: center;
    align-items: center;
    width: 90%;
    margin: 20px;
    box-shadow: 0px 2px 10px 5px rgba(0, 0, 0, 0.25);
    transition:  0.3s; 
    cursor: pointer; 
    border-radius: 5%;
}


.ourProducts_productContainer__YUXfl:hover {
    background: linear-gradient(180deg, #ffeeee 0%, #fbffc7 100.51%);
}

.ourProducts_textContainer__m4PZp {
    width: 17rem;
    height: 7rem;
    text-align: center;
    margin-top: 10px;

}

.ourProducts_productImage__mkLrt {
    height: auto;
    margin: 10px 0;
    height: 17rem;
    width: 20rem;
    border-radius: 5%;
}

.ourProducts_productSubtopic__aBBgh {
    font-size: 1.3rem;
    font-weight: 600;
    margin: 0;
    margin-bottom: 5px;
}

.ourProducts_productText__iD8W8 {
    font-size: 1rem;
    color: #1f1f1f;
    margin: 0;
    margin-bottom: 10px;
    max-width: 100%;
    line-height: 150%;
}
 .ourProducts_button__Ub7vP{
    margin-bottom: -30px;
 }

.ourProducts_cardActionBtnGroup__OjyxI{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
}

@media (max-width: 770px) {
    .ourProducts_outerContainer__Je\\+01 {
        margin: 50px;
        padding: 0px;
    }
    .ourProducts_productImage__mkLrt {
        height: auto;
        margin: 10px 0;
        height: 12rem;
        width: 15rem;
        border-radius: 5%;
    }
    .ourProducts_topic__fYv9o {
        font-size: 3rem;
        font-style: normal;
        font-weight: 600;
        margin: 0;
        margin-top: 70px;
        margin-bottom: 50px;
        display: flex;
        justify-content: center;
    }

    .ourProducts_description__SqEF1{
        margin: 20px 0px 50px 0px;
       }
}`, "",{"version":3,"sources":["webpack://./src/components/home/ourProducts.module.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,4BAA4B;IAC5B,gEAAgE;EAClE;iCAC+B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,eAAe;IACf,eAAe;IACf,8BAA8B;IAC9B,8DAA2C;IAC3C,UAAU;AACd;AACA;IACI,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI;MACE,2BAA2B;MAC3B,UAAU;IACZ;IACA;MACE,wBAAwB;MACxB,UAAU;IACZ;EACF;;EAEA;IACE,YAAY;IACZ,uBAAuB;EACzB;AACF;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,iBAAiB;IACjB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;CACC,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;CAClB,uBAAuB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gFAAgF;IAChF,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,gDAAgD;IAChD,iBAAiB;IACjB,eAAe;IACf,iBAAiB;AACrB;;;AAGA;IACI,gEAAgE;AACpE;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;;AAEpB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;CACC;IACG,oBAAoB;CACvB;;AAED;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;IAChB;IACA;QACI,YAAY;QACZ,cAAc;QACd,aAAa;QACb,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,SAAS;QACT,gBAAgB;QAChB,mBAAmB;QACnB,aAAa;QACb,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;OAC1B;AACP","sourcesContent":["/* ourProducts.module.css */\r\n.ourProductStaticBg{\r\n    /* background-color: aqua; */\r\n    /* background-image: url(\"../../assets/images/Wallpaper.jpg\"); */\r\n  /* background-repeat: no-repeat;\r\n  background-attachment: fixed; */\r\n    padding: 100px 0px;\r\n    margin-top: -100px;\r\n    z-index: 0;\r\n}\r\n.outerContainer {\r\n    margin-left: 4%;\r\n    margin-right:4%;\r\n    padding: 0px 100px 100px 100px;\r\n    animation: slideInFromBottom 1s ease-in-out;\r\n    z-index: 1;\r\n}\r\n.CardMedia{\r\n    height: 110px;\r\n    background-color: aquamarine;\r\n}\r\n\r\n@keyframes slideInFromBottom {\r\n    0% {\r\n      transform: translateY(20px); \r\n      opacity: 0; \r\n    }\r\n    100% {\r\n      transform: translateY(0); \r\n      opacity: 1; \r\n    }\r\n  }\r\n\r\n  .productCardDescription{\r\n    height: 50px;\r\n    text-overflow: ellipsis;\r\n  }\r\n.topicContainer {\r\n    text-align: center;\r\n    margin: 0 auto;\r\n}\r\n\r\n.topic {\r\n    font-size: 3rem;\r\n    font-family: \"Livvic\", serif;\r\n    font-weight: 700;\r\n    font-style: normal;\r\n    margin: 0;\r\n    margin-top: 100px;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.description{\r\n margin: 50px;\r\n align-items: center;\r\n text-align: center;\r\n justify-content: center;\r\n}\r\n\r\n.productContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    background: linear-gradient(0deg, rgba(255, 197, 197, 0.00) 0%, #fadfdf 100.51%);\r\n    border: none;\r\n    padding: 0;\r\n    text-align: center;\r\n    align-items: center;\r\n    width: 90%;\r\n    margin: 20px;\r\n    box-shadow: 0px 2px 10px 5px rgba(0, 0, 0, 0.25);\r\n    transition:  0.3s; \r\n    cursor: pointer; \r\n    border-radius: 5%;\r\n}\r\n\r\n\r\n.productContainer:hover {\r\n    background: linear-gradient(180deg, #ffeeee 0%, #fbffc7 100.51%);\r\n}\r\n\r\n.textContainer {\r\n    width: 17rem;\r\n    height: 7rem;\r\n    text-align: center;\r\n    margin-top: 10px;\r\n\r\n}\r\n\r\n.productImage {\r\n    height: auto;\r\n    margin: 10px 0;\r\n    height: 17rem;\r\n    width: 20rem;\r\n    border-radius: 5%;\r\n}\r\n\r\n.productSubtopic {\r\n    font-size: 1.3rem;\r\n    font-weight: 600;\r\n    margin: 0;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.productText {\r\n    font-size: 1rem;\r\n    color: #1f1f1f;\r\n    margin: 0;\r\n    margin-bottom: 10px;\r\n    max-width: 100%;\r\n    line-height: 150%;\r\n}\r\n .button{\r\n    margin-bottom: -30px;\r\n }\r\n\r\n.cardActionBtnGroup{\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-around;\r\n}\r\n\r\n@media (max-width: 770px) {\r\n    .outerContainer {\r\n        margin: 50px;\r\n        padding: 0px;\r\n    }\r\n    .productImage {\r\n        height: auto;\r\n        margin: 10px 0;\r\n        height: 12rem;\r\n        width: 15rem;\r\n        border-radius: 5%;\r\n    }\r\n    .topic {\r\n        font-size: 3rem;\r\n        font-style: normal;\r\n        font-weight: 600;\r\n        margin: 0;\r\n        margin-top: 70px;\r\n        margin-bottom: 50px;\r\n        display: flex;\r\n        justify-content: center;\r\n    }\r\n\r\n    .description{\r\n        margin: 20px 0px 50px 0px;\r\n       }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ourProductStaticBg": `ourProducts_ourProductStaticBg__f95iI`,
	"outerContainer": `ourProducts_outerContainer__Je+01`,
	"slideInFromBottom": `ourProducts_slideInFromBottom__SsQim`,
	"CardMedia": `ourProducts_CardMedia__lnD-r`,
	"productCardDescription": `ourProducts_productCardDescription__MDD95`,
	"topicContainer": `ourProducts_topicContainer__VP1SM`,
	"topic": `ourProducts_topic__fYv9o`,
	"description": `ourProducts_description__SqEF1`,
	"productContainer": `ourProducts_productContainer__YUXfl`,
	"textContainer": `ourProducts_textContainer__m4PZp`,
	"productImage": `ourProducts_productImage__mkLrt`,
	"productSubtopic": `ourProducts_productSubtopic__aBBgh`,
	"productText": `ourProducts_productText__iD8W8`,
	"button": `ourProducts_button__Ub7vP`,
	"cardActionBtnGroup": `ourProducts_cardActionBtnGroup__OjyxI`
};
export default ___CSS_LOADER_EXPORT___;
